module.exports = __webpack_public_path__ + "img/members.14c2df1b.svg";